import { StyledLegend } from './styles';

interface LegendProps {
  signifiers: React.ReactNode | React.ReactNode[];
}

export const Legend: React.FC<LegendProps> = ({ signifiers }) => {
  return <StyledLegend>{signifiers}</StyledLegend>;
};
